import variables from '../variables';

export const MuiAccordion = {
  root: {
    border: '0',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
  },
};

export const MuiAccordionSummary = {
  root: {
    '&$expanded': {
      margin: '0',
      minHeight: 48,
    },
  },
  content: {
    '&$expanded': {
      margin: 0,
    },
  },
  expandIcon: {
    color: variables.colors.coral,
  },
};
